import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Animated number counter that runs when scrolled into view.
export const Counter = ({ value, suffix = "", prefix = "", duration = 2000 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);
  const isNumeric = typeof value === "number";

  useEffect(() => {
    if (!inView || !isNumeric) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration, isNumeric]);

  return (
    <span ref={ref} data-testid="animated-counter">
      {prefix}
      {isNumeric ? display.toLocaleString("en-IN") : value}
      {suffix}
    </span>
  );
};

export default Counter;
